
const getSameCateInfo = {
  state: {
    info: {}
  },
  mutations: {
    SET_SameCate_Info (state, payload) {
      state.info = payload
    }
  }
}

export default getSameCateInfo



// WEBPACK FOOTER //
// ./src/store/modules/getSameCateInfo.js